import { IconButton, InputBase } from "@mui/material";
import React from "react";
import { AiOutlineSearch } from "react-icons/ai";

function TeacherPortalSearchBar({ name, setSearchQuery, setClicked }) {
    const [searchQuery, setSearchQueryState] = React.useState("");
    return (
        <div className="my-1 flex w-full items-center rounded-full bg-background px-1 py-2.5 shadow-default">
            <IconButton type="button" className="p-2.5" aria-label="search" onClick={() => {
                if (setClicked)
                    setClicked(searchQuery);
            }}>
                <AiOutlineSearch />
            </IconButton>
            <InputBase
                className="ml-1 flex-1"
                placeholder={name}
                inputProps={{ "aria-label": "search" }}
                onChange={(e) => {
                    setSearchQueryState(e.currentTarget.value);
                    if (setSearchQuery)
                        setSearchQuery(e.currentTarget.value);
                }}
                onKeyPress={(e) => {
                    if (e.key === "Enter") {
                        if (setClicked)
                            setClicked(searchQuery);
                    }
                }}
            />
        </div>
    );
}

export default TeacherPortalSearchBar;